<template>
  <div class="redemption-wrapper">
    <div class="redemption-step-back">
      <v-icon color="#333333" size="22" @click="$router.go(-1)"> mdi-arrow-left </v-icon>
    </div>
    <h2 class="redemption-header">
      {{ $i18n.t("redemptions.fromFundRedemption.title") }}
    </h2>
    <div class="customer-funds">
      <div
        v-for="(fundBalance, index) in formattedFundsBalances"
        :key="index"
        @click="selectFund(fundBalance.fundRun)"
        class="fund-balance"
      >
        <BalanceDetailsFundCard :fundBalance="fundBalance" class="fund-balance-card" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import BalanceDetailsFundCard from "../../components/results/BalanceDetailsFundCard.vue";

export default {
  name: "FromFundRedemption",

  components: { BalanceDetailsFundCard },

  computed: {
    ...mapGetters(["fundsBalances", "redemption"]),

    formattedFundsBalances() {
      return Object.values(this.fundsBalances)
        .filter(fund => fund.current > 0)
        .map(fund => ({ currencyAmount: fund.current, fundRun: fund.fundRun }))
        .sort((a, b) => b.currencyAmount - a.currencyAmount);
    },
  },

  methods: {
    ...mapActions(["setRedemptionData"]),

    selectFund(fundRun) {
      const { fundSeriesId } = this.fundsBalances[fundRun];
      this.setRedemptionData({
        ...this.redemption,
        redemptionList: [{ fundRun, fundSeriesId }],
      });
      this.$router.push({ name: "chooseRedemptionAmount" });
    },
  },
};
</script>

<style lang="scss" scoped>
.fund-balance + .fund-balance {
  margin-top: 10px;
}

.fund-balance {
  max-width: 420px;
}

.fund-balance-card {
  &:hover {
    cursor: pointer;
    background-color: #fafafa;
  }
}

::v-deep .balance-details-fund-card {
  border: none !important;
}
</style>
